import { MMDDYYYYStringToDate } from "../utils";

export const keyEvents = [
  {
    date: "03/01/2001",
    description: "Start of 2001 Recession",
  },
  {
    date: "11/01/2001",
    description: "End of 2001 Recession",
  },
  {
    date: "12/01/2007",
    description: "Start of Financial Crisis",
  },
  {
    date: "06/01/2009",
    description: "End of Financial Crisis",
  },
  {
    date: "07/01/2009",
    description: "Start of Cash For Clunkers Program",
  },
  {
    date: "11/01/2009",
    description: "End of Cash for Clunkers Program",
  },
  {
    date: "01/02/2020", // Visible on Weekly chart
    description: "Start of Covid-19 Pandemic in US",
  },
  {
    date: "05/03/2023", // Visible on Weekly chart
    description: "End of Covid-19 Pandemic in US",
  },
  {
    date: "01/01/2020", // Visible on Monthly chart
    description: "Start of Covid-19 Pandemic in US",
  },
  {
    date: "08/16/2023", 
    description: "Inflation Reduction Act EV Tax Credits Start",
  },  
  {
    date: "05/01/2023", // Visible on Monthly chart
    description: "End of Covid-19 Pandemic in US",
  },
  {
    date: "09/30/2025", 
    description: "Inflation Reduction Act EV Tax Credits Expire",
  },  
].map((event) => ({
  date: MMDDYYYYStringToDate(event.date),
  description: event.description,
}));
